(function () {
  /*
   * Shop Pay Installments (Dawn's native .installment form, rendered via
   * the payment_terms filter) has no awareness of the separate
   * Subscriptions app's purchase-option radios -- they're two independent
   * systems. The guide requires installment messaging to disappear the
   * instant a subscription frequency is selected, since installments
   * don't apply to recurring charges. The app's radios carry
   * data-radio-type="one_time_purchase" / "selling_plan"; this just
   * listens for that and toggles the installment form's visibility.
   */
  function findInstallmentForms() {
    return document.querySelectorAll('.installment');
  }

  function isSubscriptionSelected(root) {
    var checked = root.querySelector('[data-radio-type="selling_plan"]:checked');
    return !!checked;
  }

  function applyState() {
    document.querySelectorAll('[data-radio-type]').forEach(function (radio) {
      var container =
        radio.closest('.shopify_subscriptions_app_container') ||
        radio.closest('.shopify_subscriptions_app_block') ||
        radio.closest('[id^="shopify-subscriptions-app"]');
      if (!container) return;

      var subscriptionActive = isSubscriptionSelected(container);
      findInstallmentForms().forEach(function (form) {
        form.hidden = subscriptionActive;
      });
    });
  }

  function init() {
    applyState();
    document.addEventListener('change', function (event) {
      if (event.target && event.target.hasAttribute('data-radio-type')) {
        applyState();
      }
    });

    // The app can re-render its widget after variant changes; a light
    // MutationObserver keeps the installment state correct without
    // requiring the app to fire its own custom event.
    var containers = document.querySelectorAll(
      '.shopify_subscriptions_app_container, .shopify_subscriptions_app_block'
    );
    if (containers.length) {
      var observer = new MutationObserver(function () {
        applyState();
      });
      containers.forEach(function (container) {
        observer.observe(container, { childList: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
